import React from 'react';
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class ViewTourProductList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>

                {/*<h3 className="mb0 mt40">2. 파라미터 값으로 여러 여러개의 여행상품을 가져오는 API.</h3>*/}
                <h3 className="mb0 mt40">재고 조회</h3>

                <div className="blog-post-meta">
                    <span className="s-post">등록한 상품의 옵션 정보를 조회 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-primary">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/tours/{'{travelProductId}'}/items/{'{travelItemId}'}/inventories</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items/11111111/inventories
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="8" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelItemId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행 아이템 id</td>
                        </tr>
                        <tr>
                            <th colSpan="8" className="bold"> Query Parameters</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>rateType</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>BASIC</td>
                                        <td>기본</td>
                                    </tr>
                                    <tr>
                                        <td>ADULT_DAEIN_AND_CHILD_SOIN</td>
                                        <td>대인/소인동일</td>
                                    </tr>
                                    <tr>
                                        <td>ADULT</td>
                                        <td>성인</td>
                                    </tr>
                                    <tr>
                                        <td>ADULT_DAEIN</td>
                                        <td>대인</td>
                                    </tr>
                                    <tr>
                                        <td>UNIVERSITY_STUDENT</td>
                                        <td>대학생</td>
                                    </tr>
                                    <tr>
                                        <td>HIGH_SCHOOL_STUDENT</td>
                                        <td>고등학생</td>
                                    </tr>
                                    <tr>
                                        <td>MIDDLE_SCHOOL_STUDENT</td>
                                        <td>중학생</td>
                                    </tr>
                                    <tr>
                                        <td>SCHOOL_CHILD</td>
                                        <td>초등학생</td>
                                    </tr>
                                    <tr>
                                        <td>HIGH_AND_MIDDLE_SCHOOL_STUDENT</td>
                                        <td>중고생</td>
                                    </tr>
                                    <tr>
                                        <td>ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT</td>
                                        <td>초중고생</td>
                                    </tr>
                                    <tr>
                                        <td>TEENS</td>
                                        <td>청소년</td>
                                    </tr>
                                    <tr>
                                        <td>STUDENT</td>
                                        <td>학생</td>
                                    </tr>
                                    <tr>
                                        <td>PRESCHOOL_CHILD</td>
                                        <td>미취학아동</td>
                                    </tr>
                                    <tr>
                                        <td>CHILD</td>
                                        <td>아동</td>
                                    </tr>
                                    <tr>
                                        <td>CHILD_SOIN</td>
                                        <td>소인</td>
                                    </tr>
                                    <tr>
                                        <td>TODDLER</td>
                                        <td>유아</td>
                                    </tr>
                                    <tr>
                                        <td>INFANT</td>
                                        <td>영아</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>calendarDate</td>
                            <td>X</td>
                            <td>String</td>
                            <td>특정일자(Format: yyyy-MM-dd)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>List{'<InventoryDto>'}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>&nbsp;calendarDate</td>
                            <td>String</td>
                            <td>특정일자(Format: yyyy-MM-dd)</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>&nbsp;deadlineDay</td>
                            <td>Int</td>
                            <td>사용하는 날짜전에 몇 일에 프로덕트 판매를 중지시키겠습니까? 디폴트값:0</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>deadlineHour</td>
                            <td>Int</td>
                            <td>사용하는 날짜 마이너스 deadlineDay 전에 몇 시간에 프로덕트 판매를 중지시키겠습니까? 데이터는 1부터 24까지이며 디폴트값:24</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>onSale</td>
                            <td>Boolean</td>
                            <td>판매 중:true, 판매중지:false</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>rateType</td>
                            <td>String</td>
                            <td></td>
                            {/*<td>*/}
                            {/*    <table className="table table-striped">*/}
                            {/*        <tbody>*/}
                            {/*        <tr>*/}
                            {/*            <th>Optional Value</th>*/}
                            {/*            <th>Description</th>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>BASIC</td>*/}
                            {/*            <td>기본</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>ADULT_DAEIN_AND_CHILD_SOIN</td>*/}
                            {/*            <td>대인/소인동일</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>ADULT</td>*/}
                            {/*            <td>성인</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>ADULT_DAEIN</td>*/}
                            {/*            <td>대인</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>UNIVERSITY_STUDENT</td>*/}
                            {/*            <td>대학생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>HIGH_SCHOOL_STUDENT</td>*/}
                            {/*            <td>고등학생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>MIDDLE_SCHOOL_STUDENT</td>*/}
                            {/*            <td>중학생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>SCHOOL_CHILD</td>*/}
                            {/*            <td>초등학생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>HIGH_AND_MIDDLE_SCHOOL_STUDENT</td>*/}
                            {/*            <td>중고생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT</td>*/}
                            {/*            <td>초중고생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>TEENS</td>*/}
                            {/*            <td>청소년</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>STUDENT</td>*/}
                            {/*            <td>학생</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>PRESCHOOL_CHILD</td>*/}
                            {/*            <td>미취학아동</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>CHILD</td>*/}
                            {/*            <td>아동</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>CHILD_SOIN</td>*/}
                            {/*            <td>소인</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>TODDLER</td>*/}
                            {/*            <td>유아</td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td>INFANT</td>*/}
                            {/*            <td>영아</td>*/}
                            {/*        </tr>*/}
                            {/*        </tbody>*/}
                            {/*    </table>*/}
                            {/*</td>*/}
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>salePrice</td>
                            <td>Int</td>
                            <td>판매가</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>totalSoldCount</td>
                            <td>String</td>
                            <td>총판매수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>totalStockCount</td>
                            <td>String</td>
                            <td>총 재고 수량</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            {/*<h3 className="panel-title">응답값 예시</h3>*/}
                            <a data-toggle="collapse" href = "#toursResponseDto">Response Body Sample</a>
                        </div>
                        <div id = "toursResponseDto" className = "panel-collapse collapse">
                            <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "OK",
    "nextPageToken": "1573106534426",
    "size": 20,
    "data": [
        {
            "travelProductId": 515006525668851712,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-22T11:32:13.55",
            "modifiedAt": "2019-11-22T11:32:15.449"
        },
        {
            "travelProductId": 511520339147096064,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T21:13:46.422",
            "modifiedAt": "2019-11-13T07:52:14.463"
        },
        {
            "travelProductId": 511496123001602048,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T19:03:08.745",
            "modifiedAt": "2019-11-12T19:09:53.528"
        },
        {
            "travelProductId": 511493199361998848,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T18:51:31.416",
            "modifiedAt": "2019-11-12T18:51:33.011"
        },
        {
            "travelProductId": 511485095396245504,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T18:49:53.339",
            "modifiedAt": "2019-11-12T18:58:21.498"
        },
        {
            "travelProductId": 511485064899461120,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T18:49:46.063",
            "modifiedAt": "2019-11-12T18:58:20.659"
        },
        {
            "travelProductId": 511485478193594368,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T18:20:50.113",
            "modifiedAt": "2019-11-12T18:50:00.398"
        },
        {
            "travelProductId": 511468899942793216,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T18:19:49.08",
            "modifiedAt": "2019-11-12T18:49:59.633"
        },
        {
            "travelProductId": 511104860452552704,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T11:45:07.147",
            "modifiedAt": "2019-11-12T11:45:09.107"
        },
        {
            "travelProductId": 511373882012205056,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T11:44:59.29",
            "modifiedAt": "2019-11-12T11:45:01.547"
        },
        {
            "travelProductId": 511014995421560832,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-11T11:17:28.458",
            "modifiedAt": "2019-11-11T11:17:40.001"
        },
        {
            "travelProductId": 511013362465767424,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-11T11:12:50.049",
            "modifiedAt": "2019-11-11T11:13:05.581"
        },
        {
            "travelProductId": 510008242529632256,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-08T16:40:47.522",
            "modifiedAt": "2019-11-08T16:41:42.496"
        },
        {
            "travelProductId": 510006709880619008,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-08T16:24:45.278",
            "modifiedAt": "2019-11-12T11:43:45.453"
        },
        {
            "travelProductId": 509936318738857984,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-08T16:16:39.401",
            "modifiedAt": "2019-11-08T16:17:10.729"
        },
        {
            "travelProductId": 509728881356308480,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-07T22:00:49.816",
            "modifiedAt": "2019-11-07T22:00:51.318"
        },
        {
            "travelProductId": 509720793962250240,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-07T21:50:04.258",
            "modifiedAt": "2019-11-07T21:50:05.569"
        },
        {
            "travelProductId": 509707256686706688,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-07T20:36:41.435",
            "modifiedAt": "2019-11-07T20:36:43.597"
        },
        {
            "travelProductId": 90594745723791,
            "sellerProductId": "seller-product-id --- 11111",
            "vendorItemPackageId": 10000000003173,
            "productId": 98723984761,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": "COMPLETE_APPROVAL",
            "saleStatus": "SUSPENDED",
            "name": "[만리장성]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-07T17:24:25.061",
            "modifiedAt": "2019-11-14T18:03:41.71"
        },
        {
            "travelProductId": 90594745723761,
            "sellerProductId": "seller-product-id --- 11111",
            "vendorItemPackageId": 10000000003167,
            "productId": 98723984761,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": "COMPLETE_APPROVAL",
            "saleStatus": "ON_SALE",
            "name": "[만리장성]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-07T15:02:14.426",
            "modifiedAt": "2019-11-07T17:22:39.741"
        }
    ]
}
                        `}

                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V1/ProductAPI/ViewTourItemInventories.jsx